// extracted by css-extract-rspack-plugin
export default {"heading":"sJY3Hh","content":"kQ02tV"};